'use client';

import { PropsWithChildren, useEffect } from 'react';
import { useParams, useSearchParams } from 'next/navigation';

import { clientAxios } from '@/shared/api';

const ContentsDetailTemplate = ({ children }: PropsWithChildren) => {
  const params = useParams();
  const searchParams = useSearchParams();
  const id = params.id as string;

  useEffect(() => {
    // ID가 유효하지 않으면 실행하지 않음
    if (!id || id === 'undefined' || id === 'null' || isNaN(Number(id))) {
      return;
    }

    const data = searchParams.get('data');
    const source = searchParams.get('source');

    clientAxios.get('/fetchContentsDetail/', {
      params: {
        id,
        affectView: true,
        data,
        source,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{children}</>;
};

export default ContentsDetailTemplate;
